






























import { Component, Vue, Provide, Prop } from "vue-property-decorator";
@Component({
  filters: {
    praiseNum(num: number) {
      const number = Number(num);
      if (isNaN(number)) return num;
      if (number >= 10000) {
        return (number / 10000).toFixed(2) + "w";
      } else {
        return number;
      }
    },
    showTime(str: string) {
      if (str) {
        try {
          const date = new Date(str.replace(/-/g, "/")).format("MM-dd hh:mm");
          return date;
        } catch {
          return str;
        }
      }
    }
  }
})
export default class NewsItem extends Vue {
  @Prop() newsItem!: object;

  newsClick(item: object) {
    this.$emit("itemClick", item);
  }
}
